// https://stackoverflow.com/a/61226119/526709
export default function blobToBase64 (blob) {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result)
    }
  })
}